import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../../pagination.js';

export const ListOrganizationsQuerySchema = PaginationSchema.extend({
  active: z
    .enum(['true', 'false'])
    .optional()
    .transform((value) => (value === undefined ? undefined : value === 'true')),
  q: z.string().optional(),
});

export type ListOrganizationsQuery = z.infer<typeof ListOrganizationsQuerySchema>;

export const OrganizationListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  documentNumber: z.string(),
  phone: z.string().nullable(),
  legalRepresentativeName: z.string().nullable(),
  personKind: z.enum(['INDIVIDUAL', 'COMPANY']),
  active: z.boolean(),
  placesCount: z.number().int().nonnegative(),
  createdAt: z.string(),
});

export type OrganizationListItem = z.infer<typeof OrganizationListItemSchema>;

export const ListOrganizationsResponseSchema = z.object({
  items: z.array(OrganizationListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListOrganizationsResponse = z.infer<typeof ListOrganizationsResponseSchema>;
